<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Gv0HWJ/tc-custom/9798368805870.jpg?1729185142603" alt="This image is the cover for the book Ice Cream Man #37, Ice Cream Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ice Cream Man #37, Ice Cream Man
      </h1>
      <p class="bookDescription body article font2">
        <p>"Flight of the Figglybumps (Death of a Cartoonist)" They’re cute, they’re cuddly, and they’re caught up in a conflagration of candy cannons and cartoony combat! But who are the Figglybumps? And what happened to their creator? The hit horror-adjacent anthology is back—and sadder than ever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. Maxwell Prince, Martín Morazzo, Chris O’Halloran, Martín Morazzo, Chris O’Halloran
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0fda2a58